import React, { useState } from "react";
import s from "./Header.module.scss";
import {
  CaretDownOutlined,
  GlobalOutlined,
  PlusOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { Link, useNavigate } from "react-router-dom";
import { Menu, Input, Dropdown } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Sider from "antd/es/layout/Sider";
import {
  getAllSpares,
  getCarsByCategory,
  getCarsBySubcategory,
  logout,
  searchCars,
  setLang,
} from "../../redux/carSlice";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";
const { Search } = Input;

const Header = () => {
  const lang = useSelector((state) => state.cars.lang);
  const { t } = useTranslation();

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    // dispatch(getNews());
    // dispatch(getTenders());
    // dispatch(getBoardMembers());
    // dispatch(getCouncilMembers());
    // dispatch(getContacts());
    // dispatch(getConsultants());
    // dispatch(getApprisers());
    // dispatch(getReports());
    // dispatch(getInsuranceCompanies());
    // params.id && dispatch(getTenderDetails(Number(params.id)));
    // params.id && dispatch(getNewsDetails(Number(params.id)));
  };

  const items = [
    {
      key: "2",
      label: <Link to='/myAccount'> {t("personalAccount")}</Link>,
    },
    {
      key: "1",
      label: (
        <Link to='/' onClick={() => dispatch(logout())}>
          {t("logOut")}
        </Link>
      ),
    },
  ];

  const options4 = (
    <Menu>
      <Menu.Item key='1'>
        <div
          onClick={() => {
            dispatch(setLang("ru"));
            changeLang("ru");
          }}
        >
          RU
        </div>
      </Menu.Item>
      <Menu.Item key='2'>
        <div
          onClick={() => {
            dispatch(setLang("cn"));
            changeLang("cn");
          }}
        >
          CN
        </div>
      </Menu.Item>
    </Menu>
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const categories = useSelector((state) => state.cars.categories);
  const email = useSelector((state) => state.cars.email);
  const user = useSelector((state) => state.cars.userDetails);

  const onCategoryChangeHandler = async (e) => {
    e.preventDefault();

    if (e.target.innerText) {
      const categoryId = categories.find(
        (it) => it.name === e.target.innerText
      )?.id;

      if (e.target.innerText === "Запчасти") {
        navigate(`/category/${categoryId}`);
        await dispatch(getAllSpares());
      } else {
        navigate(`/category/${categoryId}`);
        await dispatch(getCarsByCategory(categoryId));
      }
    }
  };

  const onSubcategoryChangeHandler = (e) => {
    e.domEvent.stopPropagation();
    const activeSubcategory = Number(e.key);
    const activeCategory = categories.filter((it) =>
      it.sub_types.find((el) => el.id === activeSubcategory)
    )[0]?.id;

    if (activeCategory && activeSubcategory) {
      dispatch(getCarsBySubcategory({ activeCategory, activeSubcategory }));
    }
    navigate(`/category/${activeCategory}`);
  };

  const onSearch = (value, _e, info) => {
    dispatch(searchCars({ keyword: value }));
    navigate(`/category/1`);
  };

  return (
    <div className={s.header}>
      <div className={s.top}>
        <div className={s.title}>
          <Link to='/'>
            <div className={s.logo}>
              <img src='/cncars_logo.png' className={s.logoImg} />
            </div>
          </Link>
          <Link to='/'>
            <div className={s.header_text}>{t("sellCars")}</div>
          </Link>
        </div>
        <div className={s.left_top}>
          {email ? (
            <Link to='/addAnnoucement' className={s.add_btn}>
              <PlusOutlined />
              &nbsp; {t("addApplication")}
            </Link>
          ) : (
            <Link to='/login' className={s.add_btn}>
              <PlusOutlined />
              &nbsp; {t("addApplication")}
            </Link>
          )}
        </div>

        {email ? (
          <Dropdown
            menu={{
              items,
            }}
            placement='bottom'
            arrow={{
              pointAtCenter: true,
            }}
          >
            <Link to='/myAccount' className={s.myAccount}>
              {user?.photo ? (
                <img src={user?.photo} className={s.photo} />
              ) : (
                <UserOutlined className={s.icon} />
              )}
              &nbsp;
              {user?.first_name || user?.last_name
                ? `${user?.first_name} ${user?.last_name} `
                : email}
              &nbsp;
              <CaretDownOutlined />
            </Link>
          </Dropdown>
        ) : (
          <Link to='/login' className={s.myAccount}>
            <UserOutlined className={s.icon} />
            &nbsp;{t("logIn")}
          </Link>
        )}
        <Dropdown overlay={options4}>
          <ol>
            <div>
              <GlobalOutlined />
              &nbsp;{lang === "cn" ? "CN" : "RU"}{" "}
              <CaretDownOutlined style={{ fontSize: "12px" }} />
            </div>
          </ol>
        </Dropdown>
      </div>

      <div className={s.bottom}>
        <div className={s.menu}>
          <Sider onClick={(e) => onCategoryChangeHandler(e)} width={"100%"}>
            <Menu
              style={{
                background: "none",
                color: "whitesmoke",
              }}
              onClick={(e) => onSubcategoryChangeHandler(e)}
              defaultSelectedKeys={["1"]}
              defaultOpenKeys={["sub1"]}
              mode={"horizontal"}
              items={categories?.map((it) => ({
                key: it.id,
                label: it.name,
                value: it.id,

                children: it.sub_types?.map((el) => {
                  return {
                    key: el?.id,
                    label: el?.name,
                    value: el?.id,
                  };
                }),
              }))}
            />
          </Sider>
        </div>
        <div className={s.search}>
          <Search
            placeholder={`${t("search")}...`}
            className={s.search_input}
            onSearch={onSearch}
          />
        </div>
      </div>
    </div>
  );
};
// };

export default Header;
